import Insitution from './Institution'

export default Insitution
